import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, loginRequest } from "./config/authConfig";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(async () => {
  // Process any pending redirect (e.g. returning from acquireTokenRedirect).
  await msalInstance.handleRedirectPromise();

  // Pre-warm the API token cache so forms never trigger a redirect on mount.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    try {
      await msalInstance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        // Consent or MFA required — let the redirect happen once from here
        // rather than mid-form-load.
        await msalInstance.acquireTokenRedirect({ ...loginRequest, account: accounts[0] });
        return;
      }
    }
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
